import { render, staticRenderFns } from "./ItemShopField.vue?vue&type=template&id=785ff6fe&scoped=true&"
import script from "./ItemShopField.vue?vue&type=script&lang=js&"
export * from "./ItemShopField.vue?vue&type=script&lang=js&"
import style0 from "./ItemShopField.vue?vue&type=style&index=0&id=785ff6fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785ff6fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VTextField})
